import { render } from "./block-ip-addresses.vue?vue&type=template&id=b88ed8fe"
import script from "./block-ip-addresses.vue?vue&type=script&lang=js"
export * from "./block-ip-addresses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__